import { TeleService } from './telemedicine.abstract';
import { TeleCommonService } from './telecommon.service';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
declare var $: any;
declare var AgoraRTC: any;
@Injectable()
export class AgoraService extends TeleCommonService implements TeleService {

    constructor(
        public injector: Injector,
        public baseService: BaseService,
        public alerts: AlertsService
    ) {
        super(injector, baseService, alerts);
    }

    client: any;
    localTracks = {
        videoTrack: null,
        audioTrack: null
    };
    remoteUsers = {};
    speed_interval: any;
    timing_interval: any;
    network_interval: any;
    public options = {
        appid: null,
        channel: null,
        uid: null,
        token: null
    };

    init(options?) {

    }

    getDevices(cb) {
        AgoraRTC.getDevices().then(function (items) {
            items.filter(function (item) {
                return ["audioinput", "videoinput"].indexOf(item.kind) !== -1
            }).map(function (item) {
                return {
                    name: item.label,
                    value: item.deviceId,
                    kind: item.kind,
                }
            })
            var videos = []
            var audios = []
            for (let i = 0; i < items.length; i++) {
                var item = items[i]
                if ("videoinput" == item.kind) {
                    var name = item.label
                    var value = item.deviceId
                    if (!name) {
                        name = "camera-" + videos.length
                    }
                    videos.push({
                        deviceId: value,
                        name: name,
                        value: value,
                        kind: item.kind
                    })
                }
                if ("audioinput" == item.kind) {
                    var name = item.label
                    var value = item.deviceId
                    if (!name) {
                        name = "microphone-" + audios.length
                    }
                    audios.push({
                        name: name,
                        value: value,
                        kind: item.kind
                    })
                }
            }
            cb({ videos: videos, audios: audios })
        })
    }

    switchCamera(camera: any) {
        var _this = this
        this.getDevices(function (devices) {
            if (camera == false) {
                _this.localTracks.videoTrack.setDevice(devices.videos[0].value).then(() => {
                    console.log("set device success");
                }).catch(e => {
                    console.log("set device error", e);
                });
            }
            else {
                _this.localTracks.videoTrack.setDevice(devices.videos[1].value).then(() => {
                    console.log("set device success");
                }).catch(e => {
                    console.log("set device error", e);
                });
            }
        })
    }

    async joinchannel(appID: any, hasChannelValue: any, audio: any, camera: any, forceVideoStop?: any) {
        this.options.appid = appID;
        this.options.channel = hasChannelValue;
        try {
            await this.join(audio, camera, forceVideoStop)
        } catch (err) {
            console.error("Error in getting data ", err);
        }
    }

    leavechannel() {
        // $('#networkSpeed')[0].innerHTML = "";
        // $('#duration')[0].innerHTML = "";
        clearInterval(this.network_interval);
        clearInterval(this.timing_interval);
        clearInterval(this.network_interval);
        this.leave();
    }

    getBanWidth() {
        if (this.client) {
            this.speed_interval = setInterval(() => {
                if (this.client && this.client.getRTCStats()) {
                    if (this.client.getRTCStats().OutgoingAvailableBandwidth != undefined && $('#networkSpeed')[0] != undefined)
                        $('#networkSpeed')[0].innerHTML = "<i class='fa fa-wifi mx-1' aria-hidden='true'></i>" + this.changeSpeed(this.client.getRTCStats().OutgoingAvailableBandwidth)
                }
            }, 2000)

            this.timing_interval = setInterval(() => {
                if (this.client && this.client.getRTCStats()) {
                    if (this.client.getRTCStats().Duration && $('#duration')[0] != undefined)
                        $('#duration')[0].innerHTML = "<i class='fa fa-clock-o mx-1' aria-hidden='true'></i>" + this.changeTiming(this.client.getRTCStats().Duration)
                }
            }, 1000)

            this.network_interval = setInterval(() => {
                if (this.client) {
                    this.client.on("network-quality", function (stats) {
                        var arr = [1, 2, 3]
                        if (arr.includes(stats.downlinkNetworkQuality)) {
                            if ($("#networkQuality")[0])
                                $("#networkQuality")[0].innerHTML = " <i class='fa fa-signal mx-1' aria-hidden='true'></i>Good"
                        } else {
                            if ($("#networkQuality")[0])
                                $("#networkQuality")[0].innerHTML = " <i class='fa fa-signal mx-1' aria-hidden='true'></i>Bad"
                        }
                    });
                }
            }, 5000)
        }
    }

    async _subscribe(user, mediaType, _this) {
        const uid = user.uid;
        await _this.client.subscribe(user, mediaType);
        console.log("subscribe success");
        if (mediaType === 'video') {
            const player = $(`<div id="player-wrapper-${uid}">
              <div id="player-${uid}" class="player"></div>
            </div>`);
            $("#remote-playerlist").append(player);
            _this.getUId(uid).then((value) => {
                if (value == true) {
                    $(`#video_${user._videoTrack._ID}`).css({ "object-fit": "" });
                } else {
                    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                        $(`#video_${user._videoTrack._ID}`).css({ "object-fit": "cover", "width": "100%", "height": "50%", "position": "absolute", "left": "0", "top": "21%", "object-position": "center" });
                    }
                }
            })
            user.videoTrack.play(`player-${uid}`);
        }
        if (mediaType === 'audio') {
            user.audioTrack.play();
        }
        $(".additional_text")[0].innerText = "Your consultation is in progress";
    }

    handleUserUnpublished(user) {
        const id = user.uid;
        delete this.remoteUsers[id];
        // if (!user._video_muted_ && !user._audio_muted_)
        // $("#connectingText")[0].innerText = "User Left the call";
        $(".additional_text")[0].innerText = "";
        if (user._video_muted_)
            $(`#player-wrapper-${id}`).remove();
    }

    async leave() {
        for (let trackName in this.localTracks) {
            var track = this.localTracks[trackName];
            if (track) {
                track.stop();
                track.close();
                this.localTracks[trackName] = undefined;
            }
        }
        this.remoteUsers = {};
        if (!Object.keys(this.remoteUsers).length && this.baseService.authenticationService.getUserType().toLowerCase() == 'patient') {
             $(".additional_text")[0].innerText = "Doctor will join shortly";
        }
        await this.client.leave();
    }

    async join(hasmute: any, camera: any, forceVideoStop?) {
        var that = this;
        this.client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
        if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) == false)
            this.getBanWidth()
        AgoraRTC.setArea({ areaCode: "GLOBAL", excludedArea: "CHINA" });
        if (!Object.keys(that.remoteUsers).length && that.baseService.authenticationService.getUserType().toLowerCase() == 'patient') {
            $(".additional_text")[0].innerText = "Doctor will join shortly";
        }
        this.client.on("user-published", async (user, mediaType) => {
            const id = user.uid;
            that.remoteUsers[id] = user;
            try {
                that._subscribe(user, mediaType, that);
            } catch (err) {
                console.error("Error in getting data ", err);
            }
        });
        this.client.on("user-unpublished", this.handleUserUnpublished);
        [this.options.uid, this.localTracks.audioTrack, this.localTracks.videoTrack] = await Promise.all([
            this.client.join(this.options.appid, this.options.channel, this.options.token || null),
            AgoraRTC.createMicrophoneAudioTrack(),
            AgoraRTC.createCameraVideoTrack({ encoderConfig: "720p_3" })
        ]);
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? this.setUId(this.options.uid) : ""
        if (hasmute)
            this.localTracks.audioTrack.setEnabled(true)
        if (camera)
            this.localTracks.videoTrack.setEnabled(false)

        this.localTracks.videoTrack.play("local-player");
        await this.client.publish(Object.values(this.localTracks));
        if (forceVideoStop) {
            this.forceStopVideo()
        }

    }

    async muteAudio() {
        if (!this.localTracks.audioTrack) return
        await this.localTracks.audioTrack.setEnabled(false);
    }

    async unMuteAudio() {
        if (!this.localTracks.audioTrack) return
        await this.localTracks.audioTrack.setEnabled(true)
    }

    async mutecamera() {
        if (!this.localTracks.videoTrack) return
        await this.localTracks.videoTrack.setEnabled(false);
    }

    async unMuteCamera() {
        if (!this.localTracks.videoTrack) return
        await this.localTracks.videoTrack.setEnabled(true);
    }

    changeTiming(duration: any) {
        return duration < 60 ? duration + " sec" : Math.floor(duration / 60) + " min " + duration % 60 + " sec"
    }

    changeSpeed(internetSpeed: any) {
        if (internetSpeed == 0)
            return "Calculating...";
        return internetSpeed < 1001 ? internetSpeed + " Kbps" : JSON.parse(Math.floor(internetSpeed / 1000).toString() + "." + (internetSpeed % 1000).toString()[0]) + " Mbps";
    }

    lazyLoadScript(document: Document): Observable<any> {
        return super.lazyLoadScript('agora.js', document);
    }


    async forceStopVideo() {
        if (this.localTracks) {
            this.localTracks.videoTrack.close();
            await this.client.unpublish([this.localTracks.videoTrack]);
            console.log('Video track forcibly stopped.');
        }
    }
    async forceMuteAudio(): Promise<void> {
        try {
            if (!this.localTracks.audioTrack) {
                // If no audio track exists, create one first
                this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
                await this.client.publish([this.localTracks.audioTrack]);
            }

            // First stop the track to immediately cut audio
            this.localTracks.audioTrack.stop();

            // Then set enabled to false to prevent re-enabling
            await this.localTracks.audioTrack.setEnabled(false);

            // Unpublish the track from the channel
            await this.client.unpublish([this.localTracks.audioTrack]);

            // Close the track to release resources
            this.localTracks.audioTrack.close();
            this.localTracks.audioTrack = null;

            console.log("Audio forcibly muted successfully");
        } catch (err) {
            console.error("Failed to force mute audio:", err);
            throw err; // Re-throw to allow error handling by caller
        }
    }

    async forceUnmuteAudio(): Promise<void> {
        try {
            // If audio track doesn't exist or was closed, create a new one
            if (!this.localTracks.audioTrack) {
                this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
            }

            // Initialize the track if needed
            if (!this.localTracks.audioTrack.isPlaying) {
                await this.localTracks.audioTrack.setEnabled(true);
                await this.client.publish([this.localTracks.audioTrack]);
            } else {
                await this.localTracks.audioTrack.setEnabled(true);
            }

            console.log("Audio forcibly unmuted successfully");
        } catch (err) {
            console.error("Failed to force unmute audio:", err);
            throw err;
        }
    }


}